///
/// EarthBrowser
///
/// Migration v3 to v4: Fix aurora color palette fields
///
/// This migration ensures auroraColorPalette and customAuroraPalettes exist.
/// The v2→v3 migration may have failed due to state mutation issues,
/// so this re-applies the fix with proper immutable state handling.
///

interface StateV3 {
	earthbrowser?: {
		auroraColorPalette?: string
		customAuroraPalettes?: unknown[]
	}
}

/**
 * Migration from version 3 to 4: Ensure aurora palette fields exist
 * - auroraColorPalette: string (defaults to "classic")
 * - customAuroraPalettes: array (defaults to empty)
 */
export function migrateV3toV4(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV3
	const oldEarthbrowser = s.earthbrowser || {}

	// Create new earthbrowser state ensuring aurora palette fields exist
	const newEarthbrowser = {
		...oldEarthbrowser,
		auroraColorPalette: oldEarthbrowser.auroraColorPalette ?? "classic",
		customAuroraPalettes: oldEarthbrowser.customAuroraPalettes ?? []
	}

	// Return completely new state object
	return {
		...s,
		earthbrowser: newEarthbrowser
	}
}
